import React from 'react'
import styled from 'styled-components'

const Divider = styled.div`
  margin: 25px 0px 25px 0px;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.pearlGrey};
`

const RenderPaymentAndInsurance = ({ shouldRender }) => {
  return shouldRender
    ? (
      <>
        <div>
          <Divider />
          <h6>PAYMENT</h6>
          <p>
            Pay any time through June 30th, 2023 without penalty or late fee.
          </p>
        </div>
        <div>
          <Divider />
          <h6>INSURANCE</h6>
          <p>
            Insurance and the Member Assistance Program is a requirement of membership and must be paid with the membership dues. Insurance benefit amounts can be found on PGA.org and are subject to change.
          </p>
        </div>
      </>
      )
    : null
}

const RenderContributionsText = ({ shouldRender }) => {
  return shouldRender
    ? (
      <div>
        <Divider />
        <h6>CONTRIBUTIONS</h6>
        <p>
          Dues, fees, assessments, contributions or gifts to the PGA of America are not tax deductible as charitable contributions.<br /><br />
          However, they may be tax deductible as ordinary and necessary business expenses subject to restrictions imposed as a result of lobbying activities. The PGA of America estimates that the amount that may not be deducted based on lobbying is 5% of National Dues.<br /><br />
          Your voluntary donation to the PGA Financial Assistance Fund is a tax deductible contribution that will be used to support scholarship recipients and benevolent relief efforts. The voluntary contribution to The PGA Medical and Disaster Relief Fund is not tax deductible as a charitable contribution.
        </p>
      </div>
      )
    : null
}

const Legal = ({ dues, contributions }) => {
  return (
    <div>
      <RenderPaymentAndInsurance shouldRender={dues} />
      <RenderContributionsText shouldRender={contributions} />
    </div>
  )
}

export default Legal
